import { AppModule as AppModuleV1 } from "document-models/app-module/v1";
import { DocumentEditor as DocumentEditorV1 } from "document-models/document-editor/v1";
import { ProcessorModule as ProcessorModuleV1 } from "document-models/processor-module/v1";
import { SubgraphModule as SubgraphModuleV1 } from "document-models/subgraph-module/v1";
import { VetraPackage as VetraPackageV1 } from "document-models/vetra-package/v1";

/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */

export const documentModels = [
  AppModuleV1,
  DocumentEditorV1,
  ProcessorModuleV1,
  SubgraphModuleV1,
  VetraPackageV1,
] as const;
